module.exports = __webpack_public_path__ + "img/UC.6c96a0f7.jpg";